/// <amd-module name="Wit/UI/WorkItem/Components/ReferencedArtifact/ReferencedArtifactError" />
import * as React from "react";
import { Icon } from "VSSUI/Icon";

interface IReferencedArtifactErrorProps {
    error: string;
}

export const ReferencedArtifactError = (props: IReferencedArtifactErrorProps) => {
    return (
        <div className="referenced-artifact-error flex-row flex-center">
            <Icon iconName="ErrorBadge" className="font-size-ml" />
            <span className="referenced-artifact-error-text flex-grow text-ellipsis">{props.error}</span>
        </div>
    );
};
